import React, { CSSProperties } from 'react';

import Button from '@fff-web/fff-ui-shared/Button';
import styles from './WarningNote.module.scss';

export interface WarningNoteProps {
  inventoryLimit: number;
  disabledButton: boolean;
  style?: CSSProperties;
  onClickButton: () => void;
}

const getNote = (inventoryLimit: number): [string, string] => {
  if (inventoryLimit === 0) return ['This item is sold out', 'Please remove it'];
  return [
    `Only ${inventoryLimit} of this item ${inventoryLimit === 1 ? 'is' : 'are'} available`,
    'Please update quantity',
  ];
};

const WarningNote: React.FC<WarningNoteProps> = ({
  inventoryLimit,
  disabledButton,
  style,
  onClickButton,
}) => {
  const note = getNote(inventoryLimit);

  return (
    <div className={styles.container} style={style} data-testid="warning-note-container">
      <div className={styles.content}>
        <div className={styles.leftContent}>
          <i className="far fa-exclamation-circle" data-testid="warning-note-icon" />
          <p data-testid="warning-note-notice">
            {note[0]}
            {'. '}
            <Button className={styles.button} disabled={disabledButton} onClick={onClickButton}>
              {note[1]}
            </Button>
            {'.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default WarningNote;
